import { useContext } from "react"

import { FlowContext } from "#/shared/context"
import { useWalletTypeFlow } from "#/shared/hooks"

import ConnectWalletButton from "./ConnectWalletButton"

export default function ConnectWalletModalSwitchFlow() {
  const { switchFlow } = useWalletTypeFlow()
  const { isBitcoinFlow } = useContext(FlowContext)

  return (
    <ConnectWalletButton
      label={isBitcoinFlow ? "Sign in with Ethereum" : "Sign in with Bitcoin"}
      onClick={() => switchFlow()}
    />
  )
}
